<template>
  <div class="wrap">
      <iframe name="iframe1"
        ref="iframe"  class="iframe"  :src="url" 
        frameborder="0" width="350px" :height="height"></iframe>
  </div>
</template>

<script>
import {apiBaseUrl} from '@/config/env.js'
// import func from 'vue-editor-bridge'
export default {
    data() {
        return {
            height: "1000px",
            timer: null,
            id: '',
            url: '',
            nums: 10
        }
    },
    methods: {
    },
    mounted() {
        this.$api.userInfo({}).then( res =>{
          
        })

        let id = this.$route.query.id
        if(id) {
            let token = this.$storage.get('userToken')
            this.url = `${apiBaseUrl}wap/pages/form/detail/form?id=${id}&token=${token}`
            var iframes = document.getElementsByTagName('iframe');
            this.timer = setInterval(() =>{
                let height = iframes[0].contentWindow.document.body.scrollHeight
                this.height = height + 'px'

                this.nums --
                if(this.nums < 0) {
                    clearInterval(this.timer)
                }
            }, 3000)
        }
        
    },
    destroyed() {
        clearInterval(this.timer)
    }
}
</script>

<style lange="scss" scoped>
    .wrap {
        background: #fff;
        width: 100%;
        display: flex;
        align-items: center;
    }

    .iframe{
        margin: 0 auto;
        width: 400px;
    }
</style>